<button
  *ngIf="discussion.bookmarked !== null"
  type="button"
  class="btn btn-sm"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-outline-success': !discussion.bookmarked,
    'btn-success': discussion.bookmarked
  }"
  (click)="bookmarkDiscussion()"
  placement="right"
  ngbTooltip="Save and read later"
>
  <div style="display: inline-block">
    <i class="icofont icofont-book-mark"> </i>
    <span>{{ discussion.bookmarkCount }} </span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>

<button
  *ngIf="discussion.bookmarked === null"
  type="button"
  class="btn btn-sm btn-outline-success"
  [ngClass]="{ disabled: isSubmitting }"
  (click)="bookmarkDiscussion()"
  placement="right"
  ngbTooltip="Save and read later"
>
  <div style="display: inline-block">
    <i class="icofont icofont-book-mark"> </i>
    <span>{{ discussion.bookmarkCount }} </span>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
